import { AnalyticsEvent, pageSnapshotProperties, trackEvent } from '@/lib/analytics';
import type { OnboardingFormInput } from './schemas';

/**
 * webui's `phone_number` format: `+<dial digits><phone digits>`, e.g.
 * `+919876543210`. `countryCode` is the form's "+"-prefixed dial code (`+91`);
 * a bare `91` is tolerated the way webui's helper tolerated it. `''` when
 * both are empty.
 */
export function toCapturedPhoneNumber(countryCode: string, phoneNumber: string): string {
  const dial = countryCode.replace(/\s/g, '');
  const digits = phoneNumber.replace(/\D/g, '');
  if (!dial && !digits) return '';
  return dial.startsWith('+') ? `${dial}${digits}` : `+${dial}${digits}`;
}

/** The six "… captured" events for a submitted onboarding form, with webui's property keys. */
export function trackOnboardingAnswersCaptured(payload: OnboardingFormInput): void {
  const page = pageSnapshotProperties();
  trackEvent(AnalyticsEvent.IndustryOrBusinessDomainCaptured, { industry: payload.industry, ...page });
  trackEvent(AnalyticsEvent.CompanySizeCaptured, { employee_count: payload.companySize, ...page });
  trackEvent(AnalyticsEvent.MailboxesToWarmupCaptured, { mailboxes: payload.mailboxCount, ...page });
  trackEvent(AnalyticsEvent.SendEmailsPerMonthCaptured, {
    emails_per_month: payload.monthlyEmailVolume,
    ...page,
  });
  trackEvent(AnalyticsEvent.PhoneNumberCaptured, {
    phone_number: toCapturedPhoneNumber(payload.countryCode, payload.phoneNumber),
    ...page,
  });
  trackEvent(AnalyticsEvent.OutreachPlatformCaptured, { platform: payload.outreachPlatform, ...page });
}
